import React, { useState } from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';
import fr from 'facet-rest';
import useLink from 'Hooks/useLink';
import FeedbackAdditionalDetailsModal
  from 'Components/ComponentLibrary/Organisms/UserFeedback/UserFeedbackPicker/UserFeedbackQuestion/FeedbackAdditionalDetailsModal/FeedbackAdditionalDetailsModal';
import { useSnackbarContext } from 'Context/SnackbarContext';

const useStyles = buildUseStyles('YesNoQuestion', ((theme) => ({
  root: {
    display: 'flex',
    columnGap: theme.spacing(1),
  },
  button: {
    backgroundColor: theme.palette.facet.accentBlue21,
    borderRadius: theme.radius.md,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
})));

const YesNoQuestion = ({
  className,
  link,
  setHasSubmittedFeedback,
  handleOnFeedbackSubmitted,
}) => {
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);
  const [resource, setResource] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();

  const {
    loading,
    loadingError,
    collection,
  } = useLink(link);

  if (loading && loadingError) {
    return null;
  }

  const handleOnYesClicked = async () => {
    const newFeedback = collection.create();
    newFeedback.attr('answer', 'true');
    await newFeedback.submit();
    setHasSubmittedFeedback(true);

    if (handleOnFeedbackSubmitted) {
      handleOnFeedbackSubmitted(true);
    }
  };

  const handleOnNoClicked = async () => {
    const newFeedback = collection.create();
    newFeedback.attr('answer', 'false');

    try {
      const [feedback] = await newFeedback.submit();
      setResource(feedback);
      setShowModal(true);

      if (handleOnFeedbackSubmitted) {
        handleOnFeedbackSubmitted(false);
      }
    } catch (e) {
      displayErrorMessage('An error has occurred while saving your feedback');
    }
  };

  const onDialogClose = async () => {
    setShowModal(false);
    setHasSubmittedFeedback(true);
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Button1
        className={classes.button}
        color={'primary'}
        padding={'tight'}
        onClick={handleOnYesClicked}
      >
        Yes
      </Button1>

      <Button1
        className={classes.button}
        color={'primary'}
        padding={'tight'}
        onClick={handleOnNoClicked}
      >
        No
      </Button1>

      {showModal && <FeedbackAdditionalDetailsModal resource={resource} onClose={onDialogClose} />}
    </Box>
  );
};

YesNoQuestion.defaultProps = {
  className: '',
  handleOnFeedbackSubmitted: undefined,
};

YesNoQuestion.propTypes = {
  className: PropTypes.string,
  link: PropTypes.instanceOf(fr.Link).isRequired,
  setHasSubmittedFeedback: PropTypes.func.isRequired,
  handleOnFeedbackSubmitted: PropTypes.func,
};

export default YesNoQuestion;
